import { Button } from "../../../components/ui/button";
import Donate from "./Donate";

export default function GetInvolved() {
    return (
        <>
            <section className="bg-white">
                <div className="py-8 px-4 mx-auto max-w-screen-xl sm:py-16 lg:px-2">
                    {/* Title Section */}
                    <div className="text-center mb-12">
                        <h2 className="text-4xl font-bold text-green-600">Get Involved</h2>
                        <p className="text-gray-700 mt-4">
                            Join us in making a difference. Explore the ways you can contribute to our mission.
                        </p>
                    </div>

                    <div className="space-y-8 md:grid md:grid-cols-2 lg:grid-cols-3 md:space-y-0 space-x-2">
                        <div className="border rounded-lg border-gray-400 hover:shadow-xl hover:cursor-pointer">
                            <div className="mb-4 flex flex-row justify-center items-center">
                                <img src="/images/v1/img13.jpg" className="aspect-video w-full overflow-hidden rounded-t-lg object-cover transition-all duration-300" alt="Judge" />
                            </div>
                            <h3 className="text-2xl text-center font-light text-green-600">Become a Volunteer</h3>
                            <p className="text-gray-950 text-center mt-8 mb-8 font-light">
                                Join us as a volunteer and help make a difference in our various projects and initiatives.
                            </p>
                            <div className="mb-4 flex flex-row justify-center items-center">
                                <a href="mailto:info@lapa.africa?subject=Becoming a WITS Volunteer" className="pt-4 lg:pt-8" >
                                    <Button size={"lg"} className="bg-green-600 hover:bg-green-900">
                                        Become a Volunteer &rarr;
                                    </Button>
                                </a>
                            </div>
                        </div>
                        <div className="border rounded-lg border-gray-400">
                            <div className="mb-4 flex flex-row justify-center items-center">
                                <img src="/images/v1/img14.jpg" className="aspect-video w-full overflow-hidden rounded-t-lg object-cover transition-all duration-300" alt="Advocacy" />
                            </div>
                            <h3 className="text-2xl text-center font-light text-green-600">Donate</h3>
                            <p className="text-gray-950 text-center mt-8 mb-8 font-light">
                                Support our work by making a donation. <br /> Your contribution helps us continue our mission.
                            </p>
                            <div className="mb-4 flex flex-row justify-center items-center">
                                <Donate />
                            </div>
                        </div>
                        <div className="border rounded-lg border-gray-400">
                            <div className="mb-4 flex flex-row justify-center items-center">
                                <img src="/images/v1/img15.jpg" className="aspect-video w-full overflow-hidden rounded-t-lg object-cover transition-all duration-300" alt="Research" />
                            </div>
                            <h3 className="text-2xl text-center font-light text-green-600">Partner with Us</h3>
                            <p className="text-gray-950 text-center mt-8 mb-8 font-light">
                                Become a partner and collaborate with us on projects that promote sustainability and conservation.
                            </p>
                            <div className="mb-4 flex flex-row justify-center items-center">
                                <a href="mailto:info@lapa.africa?subject=Becoming a WITS Partner" className="pt-4 lg:pt-8">
                                    <Button size={"lg"} className="bg-green-600 hover:bg-green-900">
                                        Become a Partner &rarr;
                                    </Button>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}